// extracted by mini-css-extract-plugin
module.exports = {"children":"dd31006766--children--W6aYw","desktop":"dd31006766--desktop--D9bPw","mobile":"dd31006766--mobile--zOqwU"};